import React from "react";
import { Datagrid, DateField, Filter, List, SimpleShowLayout, TextField, TextInput, BooleanField, ReferenceField } from "react-admin";
import ShowView from "../../components/ShowView";

const SpecialistTransactionFilter = (props) => (
  <Filter {...props}>
    <TextInput label="شناسه" source="objectId" />
    <TextInput label="شناسه متخصص" source="specialistUserId" />
    <TextInput label="شناسه کاربر" source="userId" />
    <TextInput label="شناسه مکالمه" source="conversationId" />
  </Filter>
);

export const SpecialistTransactionList = (props) => (
  <List {...props} filters={<SpecialistTransactionFilter />}>
    <Datagrid rowClick="show">
      <TextField source="objectId" />
      <ReferenceField link="show" source="specialistUserId" reference="user">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField link="show" source="userId" reference="user">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField link="show" source="conversationId" reference="conversation">
        <TextField source="title" />
      </ReferenceField>
      <ReferenceField link="show" source="invoiceId" reference="invoice">
        <TextField source="sku" />
      </ReferenceField>
      <BooleanField source="closed" />
      <TextField source="totalMessage" />
      <TextField source="countUserMessage" />
      <DateField showTime={true} locales={"fa-IR"} source="createdAt" />
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt" />
    </Datagrid>
  </List>
);

export const SpecialistTransactionShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="objectId" />
      <ReferenceField link="show" source="specialistUserId" reference="user">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField link="show" source="userId" reference="user">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField link="show" source="conversationId" reference="conversation">
        <TextField source="title" />
      </ReferenceField>
      <ReferenceField link="show" source="invoiceId" reference="invoice">
        <TextField source="sku" />
      </ReferenceField>
      <BooleanField source="closed" />
      <TextField source="totalMessage" />
      <TextField source="countUserMessage"  />
      <DateField showTime={true} locales={"fa-IR"} source="createdAt" />
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt" />
    </SimpleShowLayout>
  </ShowView>
);
